module.exports = __webpack_public_path__ + "img/color-brush.08f85d66.svg";